/* eslint-disable no-lonely-if */
/* eslint-disable class-methods-use-this */
/* eslint-disable prefer-template */
import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
import { CONTROL_ACTIONMODE } from '../../Constants';

/**
 * フリーキャラクターテキストアイテム入力dilaogクラス
 */
export default class PinCameraInput3DDialog extends Dialog {
  guid: string = '';

  openCallback: Function = undefined;

  closeCallback: Function = undefined;

  mode: string = 'view';

  item: marietta.webcad.item.MonicaObject|null;


  /**
    * コンストラクタ
  */
  // eslint-disable-next-line no-useless-constructor
  constructor(draggable: boolean) {
    super(draggable);
  }

  /**
   *  内容の追加
   */
  buildContent() {
    // ダイアログのコンテンツ生成
    const id:string = 'pinCameraInput3DDialog';
    // タイトル
    let title:string = '';
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp': title = 'ピンテキスト'; break;
      default: title = 'Pin text'; break;
    }
    this.item = marietta.webcad.WebCADGlobal.layerGroup.getItemWithGuid(this.guid);
    let text = '';
    let linkName = '';
    let linkUrl = '';
    if (this.item) {
      text = (this.item as marietta.webcad.item.MonicaObject).itemInfo.text;
      if (this.item.itemInfo.link) {
        if (this.item.itemInfo.link.length > 0) {
          linkName = this.item.itemInfo.link[0].name;
          linkUrl = this.item.itemInfo.link[0].url;
        }
      }
    }
    let contents: string = '<div class="dialogPinTextInput3D">\n';

    contents += '<div class="dialogBodyInner">\n';

    // viewmode
    contents += '<div class="pinTextWrap viewMode">\n';
    if (linkUrl) {
      contents += '<div class="linkUrlView"><a target="_blank" href="' + linkUrl + '"><img id="pinLinkUrl" src="' + linkUrl + '"></a></div>\n';
    }
    contents += '<div class="textView"><div class="textViewWrap">' + text + '</div></div>\n';
    contents += '</div>\n';

    // editmode
    contents += '<div class="editContainer editMode">\n';
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp':
        contents += '<div class="textWrap"><textarea name="" id="pinTextInputText3D" placeholder="文字を入力してください" value="">' + text + '</textarea></div>';
        break;
      default:
        contents += '<div class="textWrap"><textarea name="" id="pinTextInputText3D" placeholder="please enter text" value="">' + text + '</textarea></div>';
        break;
    }
    contents += '<div class="docBtnWarap"><div class="error_msg editMode"></div></div>';
    contents += '</div>\n';

    contents += '</div>\n';
    contents += '</div>';
    let footer:string = '';
    footer += '<button class="viewMode" id="btnEditPin3D"><span class="jp">編集</span><span class="en">Edit</span></button>';
    footer += '<button class="editMode" id="btnDoneTextInput"><span class="jp">ＯＫ</span><span class="en">OK</span></button>';
    footer += '<button id="btnCancelTextInput"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';
    this.createDialog(id, title, contents, footer);
    (<HTMLButtonElement>document.getElementById('btnCancelTextInput')).onclick = (e: Event) => {
      this.btnCancelHandler(e);
    };
    (<HTMLButtonElement>document.getElementById('btnEditPin3D')).onclick = (e: Event) => {
      this.btnEditHandler(e);
    };
    if (document.getElementById('btnGetDoc')) {
      document.getElementById('btnGetDoc').onclick = (e: Event) => this.btnGetDocHandler(e);
    }
    if (this.openCallback != null) {
      this.openCallback();
    }
  }

  /**
   * ドキュメント データ イベント ハンドラを取得する
   * @return void
   * @param e => mouse event
   */
  protected btnGetDocHandler = (e: any) => {
    e.preventDefault();

    marietta.webcad.manager.APIManager.selectPictureDocument( this.appendDocument )
  }

  public appendDocument(checkedList = []) {
    if (checkedList.length > 0) {
      (<HTMLInputElement>document.getElementById('link_url_insert_textbox')).value = checkedList[0].file_path;
    }
  }

  updateView() {
    if (this.mode === 'edit') {
      const viewModeElem = (<HTMLElement>document.getElementById('pinCameraInput3DDialog')).getElementsByClassName('viewMode');
      for (let i = 0; i < viewModeElem.length; i += 1) {
        (viewModeElem[i] as HTMLElement).style.display = 'none';
      }
      const editModeElem = (<HTMLElement>document.getElementById('pinCameraInput3DDialog')).getElementsByClassName('editMode');
      for (let i = 0; i < editModeElem.length; i += 1) {
        (editModeElem[i] as HTMLElement).style.display = 'inline-block';
      }
      (<HTMLButtonElement>document.getElementById('btnDoneTextInput')).onclick = (e: Event) => this.btnDoneHandler(e);
    } else {
      const editModeElem = (<HTMLElement>document.getElementById('pinCameraInput3DDialog')).getElementsByClassName('editMode');
      for (let i = 0; i < editModeElem.length; i += 1) {
        (editModeElem[i] as HTMLElement).style.display = 'none';
      }
      const viewModeElem = (<HTMLElement>document.getElementById('pinCameraInput3DDialog')).getElementsByClassName('viewMode');
      for (let i = 0; i < viewModeElem.length; i += 1) {
        (viewModeElem[i] as HTMLElement).style.display = 'inline-block';
      }
    }
  }

  /**
   *
   * @return void
   * @param e => mouse event
  */
  btnEditHandler = (e: any) => {
    e.preventDefault();
    this.mode = 'edit';
    this.updateView();
  }

  /**
   * OKボタンがクリックされた
   * @return void
   * @param e => mouse event
  */
  btnDoneHandler = (e: any) => {
    e.preventDefault();
    let textErrorMsg = '';
    let linkErrorMsg = '';
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp':
        textErrorMsg = '文字を入力してください。';
        linkErrorMsg = '指定のURLを入力してください。';
        break;
      default:
        textErrorMsg = 'Please enter input text';
        linkErrorMsg = 'please enter specified URL.';
        break;
    }

    const textAreaVal = (<HTMLInputElement>document.getElementById('pinTextInputText3D')).value;
    let errorMsg = '';
    if (textAreaVal === '') {
      errorMsg = textErrorMsg;
    }
    if (errorMsg) {
      // エラーメッセージ表示
      (<HTMLElement>document.getElementById('pinCameraInput3DDialog')).getElementsByClassName('error_msg')[0].innerHTML = errorMsg;
    } else {
      (<HTMLElement>document.getElementById('pinCameraInput3DDialog')).getElementsByClassName('error_msg')[0].innerHTML = '';
      (this.item as marietta.webcad.item.MonicaObject).itemInfo.text = textAreaVal;
      this.item.reCreateImage();
      let textArray: string[] = [];
      if (textAreaVal.indexOf('\n') !== -1) {
        textArray = textAreaVal.split('\n');
      } else {
        textArray[0] = textAreaVal;
      }
      const text = textArray.join('<br>');
      (<HTMLElement>document.getElementById('pinCameraInput3DDialog')).getElementsByClassName('textViewWrap')[0].innerHTML = text;
      this.mode = 'view';
      this.updateView();
    }
  }

  /**
   * Cancelボタンがクリックされた
   * @return void
   * @param e => mouse event
  */
  btnCancelHandler = (e: any) => {
    e.preventDefault();
    if (this.mode === 'edit') {
      this.mode = 'view';
      this.updateView();
    } else {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
      // パネルを閉じる
      this.close();
    }
  }

  /**
  * 閉じるボタンが押された
  */
  close = () => {
    marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
    this.closeEvent();

    if (this.closeCallback != null) {
      this.closeCallback();
    }
  }
}
